<template>
  <div class="header">
    <div class="header-left">
      <img :src=logoPng alt="">
      <span>伏云智维</span>
      <div class="header-line"></div>
      <span>西安</span>
    </div>
    <div class="header-middle">
<!--      <div :class="titleId==1?'class-title':'title'" @click="titleId=1">-->
<!--        <a href="#index">首页</a>-->
<!--      </div>-->
<!--      <div :class="titleId==2?'class-title':'title'" @click="titleId=2">-->
<!--        <a href="#main-gn">公司简介</a>-->
<!--      </div>-->
<!--      <div :class="titleId==3?'class-title':'title'" @click="titleId=3">-->
<!--        <a href="#main-three">主营产品</a>-->
<!--      </div>-->
<!--      <div :class="titleId==4?'class-title':'title'" @click="titleId=4">-->
<!--        <a href="#main-img">客户案例</a>-->
<!--      </div>-->
<!--      <div :class="titleId==5?'class-title':'title'" @click="titleId=5">-->
<!--        <a href="#main-footer">联系我们</a>-->
<!--      </div>-->
      <div v-for="(item) in menuList" :key="item.name">
        <a :href="item.herf">{{item.name}}</a>
      </div>
    </div>
    <div class="header-right">
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2062_28875)">
          <circle cx="18" cy="18" r="15.5" stroke="black"/>
          <path d="M15.232 11.9297C15.5018 11.9297 15.7503 12.076 15.8813 12.3118L16.7896 13.948C16.9085 14.1623 16.9141 14.4214 16.8045 14.6406L15.9295 16.3907C15.9295 16.3907 16.1831 17.6944 17.2444 18.7557C18.3056 19.817 19.605 20.0662 19.605 20.0662L21.3549 19.1913C21.5742 19.0816 21.8335 19.0873 22.0478 19.2065L23.6886 20.1187C23.9243 20.2498 24.0704 20.4981 24.0704 20.7677V22.6515C24.0704 23.6108 23.1794 24.3036 22.2704 23.9969C20.4036 23.367 17.5058 22.1677 15.6691 20.331C13.8324 18.4943 12.6331 15.5965 12.0032 13.7297C11.6965 12.8207 12.3893 11.9297 13.3486 11.9297H15.232Z" fill="black" stroke="black" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0_2062_28875">
            <rect width="36" height="36" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <span>029-68790192</span>
    </div>
  </div>
</template>

<script>
import leftPng from '@/assets/image/left.png'
import rightPng from '@/assets/image/right.png'
import phonePng from '@/assets/image/phone.png'
import logoPng from '@/assets/image/logo.png'
export default {
  name: "MainPage",
  data(){
    return{
      leftPng,rightPng,phonePng,logoPng,
      titleId:1,
      nav_show:0,
      active: 0, // 当前激活的导航索引
      menuList: [
        { name: '首页',
          herf:'#index'
        },
        { name: '公司简介' ,
          herf:'#main-gn'
        },
        { name: '主管产品',
          herf:'#main-three'},
        { name: '客户案例',
          herf:'#main-img'},
        { name: '联系我们',
          herf:'#main-footer'
        },
      ]
    }
  },
  methods: {
    handleScroll() {
      // // 获取所有锚点元素
      // const navContents = document.querySelectorAll('.item')
      // // 所有锚点元素的 offsetTop
      // const offsetTopArr = []
      // navContents.forEach(item => {
      //   offsetTopArr.push(item.offsetTop)
      // })
      // // // 获取当前文档流的 scrollTop
      // const scrollTop = document.documentElement.scrollTop + 40 || document.body.scrollTop + 40
      // // // 定义当前点亮的导航下标
      // let navIndex = 0
      // let count = 0
      // let menu = document.querySelectorAll('.header-middle');
      // for (let n = 0; n < offsetTopArr.length; n++) {
      //   // 如果 scrollTop 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
      //   // 那么此时导航索引就应该是 n 了
      //   if (scrollTop >= offsetTopArr[n]) {
      //     navIndex = n
      //     if (navIndex >= 8) count++
      //   }
      // }
      //当前active菜单赋值
      // this.active = navIndex
      // // 滚动到一定位置 将菜单整体向上移  确保能看的到更多的菜单
      // if (navIndex >= 8) {
      //   menu.style.top = - 100 * count + 'px'
      // } else {
      //   menu.style.top = 0 + 'px'
      // }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll,true)
  },
  // 组件销毁前
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss" scoped>
.header{
  position: fixed;
  top: 0;
  z-index: 999;
  background: #FFFFFF;
  box-shadow: 0px 5px 10px rgba(13, 67, 121, 0.15);
}
.header{
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  .header-left{
    width: 25%;
    display: flex;
    align-items: center;
    font-family: 'HYQiHei';
    font-weight: 400;
    font-size: 28px;
    color: #031222;
    padding-left: 80px;
    gap: 8px;
    .header-line{
      width: 2px;
      height: 20px;
      background: linear-gradient(90deg, rgba(3, 18, 34, 0) 0%, rgba(3, 18, 34, 0.2) 46.35%, rgba(3, 18, 34, 0) 100%);
    }
  }
  .header-middle{
    width: 50%;
    display: flex;
    justify-content: center;
    gap: 80px;
    a{
      font-family: 'PingFang SC';
      font-weight: 500;
      font-size: 16px;
    }
    .title{
      height: 46px;
      display: flex;
      align-items: center;
    }
    .class-title{
      height: 48px;
      display: flex;
      align-items: center;
      border-bottom:2px solid #1187FF;
    }
    .title-class{
      height: 48px;
      display: flex;
      align-items: center;
      border-bottom:2px solid #1187FF;
    }
  }
  .header-right{
    width: 25%;
    display: flex;
    justify-content: end;
    align-items: center;
    padding-right: 80px;
    font-family: 'FF DIN Pro';
    font-weight: 700;
    font-size: 24px;
    color: #031222;
    gap: 8px;
  }
}
</style>